import React, { useState, useEffect } from "react";

import AudioRecorder from "../components/BehaviouralTest/audio_recorder";
import { useNavigate } from "react-router-dom";
import AssessmentSideBar from "../components/AssessmentSideBar";

import { useTimerContext } from "@/context/TimerContext";
import QuestionCountCard from "@/components/QuestionCountCard";
import AssessmentLableAndTimer from "@/components/AssessmentLableAndTimer";
import AssessmentProgressBar from "@/components/AssessmentProgressBar";
import AssessmentPagesFooter from "@/components/AssessmentPagesFooter";
const BehaviouralTest: React.FC = () => {
	const { timeLeft, setTimeLeft, isTimeUp, setIsTimeUp } = useTimerContext();
	const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
	const [behavioralQuestions, setBehavioralQuestions] = useState<any[]>([]);
	const [buttonToggle, setButtonToggle] = useState(false);
	const [answeredQuestion, setAnsweredQuestion] = useState<Record<number, string>>({});

	const navigate = useNavigate();

	const complete = () => {
		const assessmentData = JSON.parse(sessionStorage.getItem("question") || "{}");
		delete assessmentData?.Behaviour_q;
		sessionStorage.setItem("question", JSON.stringify(assessmentData));
		sessionStorage.setItem("assessmentSection", "technical");
		navigate("/highlights");
	};

	const onToNextQuestion = () => {
		if (currentQuestionIndex < behavioralQuestions.length - 1) {
			setCurrentQuestionIndex((prev) => prev + 1);
			setButtonToggle(false); // reset for next question
		} else {
			complete();
		}
	};

	const markAnsweredQuestion = () => {
		setAnsweredQuestion((prev) => ({
			...prev,
			[currentQuestionIndex]: "yes",
		}));
	};

	// Load questions safely
	useEffect(() => {
		setTimeLeft(120);
		setIsTimeUp(false);

		try {
			const storedData = sessionStorage.getItem("question");
			if (!storedData) throw new Error("No session data");

			const parsed = JSON.parse(storedData);
			const questions = parsed?.Behaviour_q;

			if (!Array.isArray(questions) || questions.length === 0) {
				throw new Error("Behavioral questions missing or invalid");
			}

			setBehavioralQuestions(questions);
		} catch (err) {
			console.warn("Error loading behavioral questions:", err);
			sessionStorage.setItem("assessmentSection", "technical");
			navigate("/highlights");
		}
	}, [navigate, setTimeLeft, setIsTimeUp]);

	// Set question ID in localStorage when question changes
	useEffect(() => {
		if (behavioralQuestions.length > 0) {
			const questionId = behavioralQuestions[currentQuestionIndex]?.b_question_id;
			if (questionId) {
				localStorage.setItem("question_id", questionId);
			}
		}
	}, [currentQuestionIndex, behavioralQuestions]);

	// Automatically go to next question if time is up
	useEffect(() => {
		if (isTimeUp && behavioralQuestions.length > 0) {
			onToNextQuestion();
		}
	}, [isTimeUp, behavioralQuestions]);

	// Get candidate_id from session
	const candidate_id = (() => {
		try {
			const data = JSON.parse(sessionStorage.getItem("question") || "{}");
			return data?.candidate_id || "";
		} catch {
			return "";
		}
	})();

	return (
		<>
			<div className="min-h-[90vh]">
				<AssessmentSideBar />

				<AssessmentProgressBar
					current={currentQuestionIndex}
					total={behavioralQuestions.length}
				/>

				<div className="h-full flex justify-center gap-5 items-start mt-3">
					<div className="w-3/5 mx-3 rounded-xl">
						<div className="border-1 rounded-xl">
							<AssessmentLableAndTimer
								timeLeft={timeLeft}
								label="Behavioural Test"
							/>
						</div>

						<div className="mx-auto p-4 bg-white rounded-b-lg border-1">
							<div className="text-lg">
								{currentQuestionIndex + 1}.{" "}
								{behavioralQuestions[currentQuestionIndex]?.b_question_text}
							</div>

							<div className="flex justify-center mt-2">
								<AudioRecorder
									question_id={
										behavioralQuestions[currentQuestionIndex]?.b_question_id
									}
									candidate_id={candidate_id}
									jobId={localStorage.getItem("job_id")}
									setButtonToggle={setButtonToggle}
									markAnsweredQuestion={markAnsweredQuestion}
								/>
							</div>
						</div>

						<div className="flex justify-center my-4">
							{currentQuestionIndex === behavioralQuestions.length - 1 ? (
								<button
									onClick={complete}
									className="bg-black text-white px-6 py-2 rounded-lg"
								>
									Finish
								</button>
							) : (
								<button
									onClick={onToNextQuestion}
									className={`font-body text-white px-4 py-2 rounded-md ml-4 ${!buttonToggle
											? "bg-gray-500 cursor-not-allowed"
											: "bg-black"
										}`}
									disabled={!buttonToggle}
								>
									Next Question
								</button>
							)}
						</div>
					</div>

					<div>
						<QuestionCountCard
							selectedAnsawer={answeredQuestion}
							currentQuestionIndex={currentQuestionIndex}
							totalQuestion={behavioralQuestions.length}
						/>
					</div>
				</div>
			</div>

			<AssessmentPagesFooter />
		</>
	);
};


export default BehaviouralTest;
